<div class="flexible-column">
  <header>
    <app-header></app-header>
  </header>
  <div class="flex-grow">
    <div class="flexible-column">
      <!-- <div class="outer-conatiner"> -->
      <!-- <div class="code-enf-wrapper"> -->
      <!-- <div class="display-flex"> <app-page-title class="test" pageTitle='Case History'>
        </app-page-title>
    </div> -->
      <div class="display-flex">
        <app-page-title class="test" pageTitle='Case History'>
        </app-page-title>
        <button style="color: #6A0721;" (click)="openDialogForSearch()">
          Advanced Search
          <span class="material-icons">
            search
          </span>
        </button>
      </div>
      <!-- </div> -->
      <div *ngIf="showSpinner; else content" class="flex-grow">
        <app-spinner style="position: absolute;top: 40%;"></app-spinner>
      </div>
      <ng-template #content>
        <div *ngIf="expiredCaseList != undefined && expiredCaseList.length">
          <div class="box">
            <table mat-table #table [dataSource]="dataSource" multiTemplateDataRows matSort>
              <ng-container [matColumnDef]="column" *ngFor="let column of columnNames;">
                <span *ngIf='column == "timeline"'>
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let row">
                    <span (click)="expandedElement = expandedElement === row ? null : row"
                      class="material-icons custom-material-icon">keyboard_arrow_down</span>
                  </td>
                </span>
                <ng-container *ngIf="column !== 'actions'">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{tableColumnsNames ? tableColumnsNames[column] : column}} </th>
                  <td mat-cell [title]=object[column] class="extra-cls" *matCellDef="let object"> {{object[column]}}
                  </td>
                </ng-container>
              </ng-container>
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="expiredCaseList.length">
                  <div class="example-element-detail"
                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="example-element-diagram">
                      <mat-horizontal-stepper [linear]="isLinear" #stepper>
                        <mat-step *ngFor="let violation of element.viloationHistory">
                          <ng-template matStepLabel>{{violation.category}}
                            <span class="time-date">{{violation.date|date:'dd/MM/yy'}}</span>
                          </ng-template>
                        </mat-step>
                        <!-- <mat-step>
                                <ng-template matStepLabel>Resolved {{element.Category == 'Resolved'}}</ng-template>
                            </mat-step> -->
                        <!-- <mat-step> mat-step-icon-selected "element.Category == 'Resolved'"
                              <ng-template matStepLabel>hhh</ng-template>
                            </mat-step>
                            <mat-step>
                                <ng-template matStepLabel>uwu</ng-template>
                              </mat-step>
                            <mat-step>
                              <ng-template matStepLabel>Done</ng-template>
                            </mat-step> -->
                      </mat-horizontal-stepper>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
              <!-- <tr mat-row *matRowDef="let row; columns: columnNames;"></tr>
            <tr mat-row *matRowDef="let row; columns: ['split']" class="split-row">
            </tr> -->
              <tr mat-row *matRowDef="let row; columns: columnNames;" class="example-element-row"
                [class.example-expanded-row]="expandedElement === row">
              </tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
        <p *ngIf="expiredCaseList == undefined || expiredCaseList.length == 0" class="no-data">No Data Found</p>       
      </ng-template>

    </div>
  </div>
  <ng-template #searchFormRef>
    <div class="dialog-Container">
      <mat-dialog-actions class="d-inline-block float-right">
        <h4 class="d-inline-block">Advanced Search</h4>
        <button mat-dialog-close class="dialog-btn-trans text-white">X</button>
      </mat-dialog-actions>
      <mat-dialog-content class="dialog-content">
        <!-- <p class="sub-form-title mandator-title dialog-sub-title">* All fields are required</p> -->
        <form class="address-form" action="" [formGroup]="searchForm" (submit)="fetchAllCases()">
          <mat-form-field appearance="fill">
            <mat-label>Case</mat-label>
          <input matInput type="test" formControlName="case"/>
            <!-- <mat-label>Case</mat-label>
            <input type="text" aria-label="Number" matInput formControlName="case" [matAutocomplete]="auto">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete> -->
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Category</mat-label>
            <mat-select formControlName="categoryId">
              <mat-option *ngFor="let category of categories" [value]="category.id">{{category.category}}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="onSubmitSearchForm.get('categoryId').hasError('required')">
           Please select days to cure    
         </mat-error> -->
            <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
          Special character or space not allow at start
        </mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Status</mat-label>
            <mat-select formControlName="statusId">
              <mat-option *ngFor="let status of status" [value]="status.id">{{status.status}}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="onSubmitSearchForm.get('statusId').hasError('required')">
         Please select days to cure    
       </mat-error> -->
            <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
        Special character or space not allow at start
      </mat-error> -->
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Expired/Not Expired</mat-label>
            <mat-select formControlName="isExpired">
              <mat-option [value]="1">Expired</mat-option>
              <mat-option [value]="0">Not Expired</mat-option>
              <!-- <mat-option  *ngFor="let status of status"  [value]="status.id">{{status.status}}</mat-option> -->
            </mat-select>
            <!-- <mat-error *ngIf="onSubmitSearchForm.get('isExpired').hasError('required')">
       Please select days to cure    
     </mat-error> -->
            <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
      Special character or space not allow at start
    </mat-error> -->
          </mat-form-field>
          <button mat-button class="button-primary" type="submit" color="vov-ui-primary">Search</button>
          <span><a style="padding:22px;text-decoration: none; color: #6A0721;
            font-weight: bold;" [routerLink]="" color="vov-ui-primary" (click)="reset()">Reset</a></span>
          <!-- <button mat-button  class="button-primary" [disabled]='updateCaseListForm.invalid' type="submit"
          color="vov-ui-primary">Update case</button> -->
        </form>
      </mat-dialog-content>
    </div>
  </ng-template>
</div>
